export default {"src":"/_next/static/media/userRoleIconSelected.bbc3b2fa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};